export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20streetwear%20lifestyle%20photography%20with%20colorful%20sneakers%20on%20concrete%20urban%20texture%2C%20dynamic%20composition%20with%20warm%20golden%20hour%20side%20lighting%2C%20editorial%20fashion%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20dark%20moody%20shadows%2C%20rich%20terracotta%20and%20cream%20color%20palette%2C%20high%20contrast%20dramatic%20look&width=1600&height=900&seq=hero-hoobuy-v2&orientation=landscape"
          alt="Hoobuy Spreadsheet - Melhores produtos e links"
          title="Hoobuy Spreadsheet 2026 - Links Atualizados"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <p className="text-white/75 text-xs md:text-sm font-medium tracking-[0.25em] uppercase mb-4">
          Hoobuy Spreadsheet 2026
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          A Maior Hoobuy Spreadsheet<br />
          <span className="italic font-normal text-white/80">em Português</span>
        </h1>
        <p className="text-white/65 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          Mais de 5.000 produtos organizados: Sneakers, Streetwear, Luxury Bags, Jerseys e Watches. Atualizado diariamente.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            Ver Spreadsheet Agora
          </a>
          <a
            href="#categorias"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/50 text-white font-medium text-sm hover:bg-white/15 transition-all cursor-pointer whitespace-nowrap"
          >
            Encontrar Produtos
          </a>
        </div>
      </div>
    </section>
  );
}